<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-subscription-dialog-form">
    <mat-form-field>
      <mat-label>Subscription Name</mat-label>
      <input matInput
             name="data.subscriptionName"
             [(ngModel)]="data.subscriptionName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Subscription Level</mat-label>
      <input matInput
             name="data.subscriptionLevel"
             readonly="readonly"
             [(ngModel)]="data.subscriptionLevel" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Period Type</mat-label>
      <mat-select name="data.periodTypeId" [(ngModel)]="data.periodTypeId">
        <mat-option *ngFor="let periodType of data.allPeriodTypes"
                    [value]="periodType.periodTypeId">{{ periodType.description }}</mat-option>
      </mat-select>
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>subscriptionType</mat-label>
      <input matInput
             name="data.subscriptionType"
             readonly="readonly"
             [(ngModel)]="data.subscriptionType" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Created Date</mat-label>
      <input matInput
             [matDatepicker]="createdDatePicker"
             name="data.createdDate"
             [(ngModel)]="data.createdDate" />
      <mat-datepicker-toggle matSuffix
                             [for]="createdDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #createdDatePicker></mat-datepicker>
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Expiration Date</mat-label>
      <input matInput
             [matDatepicker]="expirationDate"
             name="data.expirationDate"
             [(ngModel)]="data.expirationDate" />
      <mat-datepicker-toggle matSuffix
                             [for]="expirationDate"></mat-datepicker-toggle>
      <mat-datepicker #expirationDate></mat-datepicker>
    </mat-form-field><br />
    <ng-container>
      <mat-checkbox name="data.autoRenew" [(ngModel)]="data.autoRenew">Auto Renew</mat-checkbox>
    </ng-container><br />
    <mat-form-field>
      <mat-label>Max Admin Users</mat-label>
      <input matInput
             name="data.maxAdminUsers"
             [(ngModel)]="data.maxAdminUsers" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Max Designer Users</mat-label>
      <input matInput
             name="data.maxDesignerUsers"
             [(ngModel)]="data.maxDesignerUsers" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Max Dashboard Users</mat-label>
      <input matInput
             name="data.maxDashboardUsers"
             [(ngModel)]="data.maxDashboardUsers" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Max Report Users</mat-label>
      <input matInput
             name="data.maxReportUsers"
             [(ngModel)]="data.maxReportUsers" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Organization Name</mat-label>
      <input matInput
             name="data.organizationName"
             [(ngModel)]="data.organizationName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Purchaser First Name</mat-label>
      <input matInput
             name="data.purchaserFirstName"
             [(ngModel)]="data.purchaserFirstName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Purchaser Last Name</mat-label>
      <input matInput
             name="data.purchaserLastName"
             [(ngModel)]="data.purchaserLastName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Purchaser Title</mat-label>
      <input matInput
             name="data.purchaserTitle"
             [(ngModel)]="data.purchaserTitle" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Purchaser Email</mat-label>
      <input matInput
             name="data.purchaserEmail"
             [(ngModel)]="data.purchaserEmail" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Purchaser Phone</mat-label>
      <input matInput
             name="data.purchaserPhone"
             [(ngModel)]="data.purchaserPhone" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Address Line 1</mat-label>
      <input matInput
             name="data.address1"
             [(ngModel)]="data.address1" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Address Line 2</mat-label>
      <input matInput
             name="data.address2"
             [(ngModel)]="data.address2" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>City</mat-label>
      <input matInput
             name="data.city"
             [(ngModel)]="data.city" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>State</mat-label>
      <input matInput
             name="data.state"
             [(ngModel)]="data.state" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Zip</mat-label>
      <input matInput name="data.zip" [(ngModel)]="data.zip" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Phone</mat-label>
      <input matInput
             name="data.phone"
             [(ngModel)]="data.phone" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Tax Exempt ID</mat-label>
      <input matInput
             name="data.taxExemptId"
             [(ngModel)]="data.taxExemptId" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Tax Exempt Expire Date</mat-label>
      <input matInput
             name="data.taxExemptExpireDate"
             [(ngModel)]="data.taxExemptExpireDate" />
    </mat-form-field><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
